import { createContext, useEffect, useState } from 'react';
import axios from 'axios'; // custom axios with credentials

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    axios.get('/api/auth/check')
      .then(res => {
        if (res.data.loggedIn) setUser(res.data.user);
        setChecking(false);
      })
      .catch(() => setChecking(false));
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {!checking && children}
    </AuthContext.Provider>
  );
};